<!-- 资产归领主页面 -->
<template>
  <div class="section-main__warp recipient-wrap">
    <ioc-table ref="crud"
               v-model="recipient"
               :data="tableData"
               :option="option"
               :page="page"
               @row-save="handleCreate"
               @search-change="handleSearchChange"
               @search-reset="handleSearchReset"
               @size-change="handleSizeChange"
               @current-change="handleCurrentChange"
               @row-cancle="closeDialog">
      <!-- 顶部按钮 自定义 -->
      <template slot="menuLeft">
        <el-button v-auth="'/assets/assetsRecipient:add'"
                   type="primary"
                   size="small"
                   class="iss-operation-button"
                   icon="el-icon-plus"
                   @click="handleAddAccount">
          {{$t('workGroup.button.add')}}
        </el-button>
      </template>
      <!-- 表格按钮 自定义 -->
      <template slot="menu"
                slot-scope="scope">
        <el-tooltip class="item"
                    effect="dark"
                    content="归还"
                    placement="top"
                    popper-class="tooltip-draw">
          <el-button v-auth="'/assets/assetsRecipient:returned'"
                     type="text"
                     icon="iconfont-lunan icon-lunan-recipient"
                     @click="handleReturn(scope.row)"></el-button>
        </el-tooltip>
        <el-tooltip class="item"
                    effect="dark"
                    content="详情"
                    placement="top"
                    popper-class="tooltip-draw">
          <el-button type="text"
                     icon="iconfont icon-Detail"
                     @click="handleView(scope.row)"></el-button>
        </el-tooltip>
      </template>
      <!-- 表格列 自定义 -->
      <template slot="fireassetCode"
                slot-scope="scope">
        <vue-qr :text="scope.row.fireassetName"
                :size="50"
                :margin="5"></vue-qr>
      </template>
      <!-- 新增/修改表单 自定义 -->
      <template slot="addFormSet">
        <div class="add_rec">
          <el-button icon="el-icon-plus"
                     type="primary"
                     size="small"
                     @click="addShow=true">添加资产</el-button>
          <div class="add_rec_content"
               v-if="addShow">
            <div class="add_rec_select">
              <div>
                <label for="">资产类型：</label>
                <el-select v-model="fireassetType"
                           placeholder="请选择"
                           @change="assetTypeChange">
                  <el-option v-for="item in assetsTypeExistOption"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div>
                <label for="">资产名称：</label>
                <el-select v-model="fireassetName"
                           placeholder="请选择"
                           multiple
                           collapse-tags>
                  <el-option v-for="item in fireassetNameOption"
                             :key="item.fireassetCode"
                             :label="item.fireassetName"
                             :value="item.fireassetName">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="add_rec_btn">
              <el-button type="primary"
                         @click="submitAddAssets">确定</el-button>
              <el-button type="info"
                         @click="addShow=false">取消</el-button>
            </div>
          </div>
        </div>
        <ioc-table ref="addRecipient"
                   v-model="addRecipient"
                   :data="addTableData"
                   :option="addOption"
                   :page="{}">
        </ioc-table>
      </template>
    </ioc-table>
    <assets-return ref="assetsReturn"
                   @returnAssets="returnAssets"
                   :personList="personList"></assets-return>
    <return-detail ref="detail"></return-detail>
  </div>
</template>
<script>
import { api } from '../api'
import utils from '@src/common/utils'
import tableOption from '../const/recipientOption'
import addOption from '../const/addRecipient'
import assetsReturn from '../components/assetsReturn'
import returnDetail from '../components/returnDetail'
import { Dic, Dates } from '$utils'
export default {
  components: {
    assetsReturn,
    returnDetail
  },
  data () {
    return {
      recipient: {},
      addRecipient: {},
      tableData: [],
      addTableData: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10
      },
      searchParams: {},
      option: tableOption(this),
      addOption: addOption(this),
      recipientGroups: [],
      addShow: false,
      fireassetType: '',
      fireassetName: [],
      assetsTypeExist: [],
      assetsTypeExistOption: [],
      assetsType: Dic.find('SENU077'),
      fireassetNameOption: [],
      personList: []
    }
  },
  mounted () {
    this.getList()
    this.queryAssetsType()
  },
  created () {
    this.queryPersonList()
  },
  methods: {
    // 根据现有资产类型 过滤枚举表
    queryAssetsType () {
      this.$fetch(api.assetsManage.queryAssetsTypeList).then(res => {
        if (!res.success) {
          this.$message.error(res.msgContent)
        } else {
          const assetsTypeNum = res.returnObj
          console.log('assetsTypeNum', assetsTypeNum)
          if (this.assetsType && this.assetsType.length) {
            this.assetsType.map(item => {
              assetsTypeNum.map(numItem => {
                if (item.value === numItem.fireassetType) {
                  this.assetsTypeExist.push(item)
                  this.assetsTypeExistOption.push(item)
                }
              })
            })
          }
          this.option.column[2].dicData = [].concat(this.assetsTypeExistOption)
        }
      })
    },
    // 获取人员与工号
    queryPersonList () {
      const params = {
        personnelType: 1,
        status: 1,
        pageNum: 1,
        pageSize: 10000
      }
      this.$fetch(api.assetsManage.queryPersonList, params).then(res => {
        if (res && res.success) {
          if (res.returnObj.list && res.returnObj.list.length) {
            res.returnObj.list.map(item => {
              this.personList.push({
                label: item.name,
                value: item.workNo
              })
            })
            this.option.column[1].dicData = [].concat(this.personList)
          }
        } else {
          this.$message.error(res.msgContent)
        }
      })
    },
    // 选择资产类型时 查询对应资产名称
    assetTypeChange (val) {
      this.fireassetName = []
      this.$fetch(api.assetsManage.queryAssetsByType,
        { fireassetType: val, status: 0 }
      ).then(res => {
        if (res && res.success) {
          this.fireassetNameOption = res.returnObj
        } else {
          this.$message.error(res.msgContent)
        }
      })
    },
    // 确认新增一条资产领用
    submitAddAssets () {
      this.assetsTypeExistOption = this.assetsTypeExistOption.filter(item => {
        return item.value !== this.fireassetType
      })
      if (!(this.fireassetType && this.fireassetName && this.fireassetName.length)) {
        this.$message.warning('请选择资产')
        return false
      }
      this.addTableData.push({
        fireassetType: Dic.findByValue('SENU077', this.fireassetType),
        fireassetName: this.fireassetName.toString(),
        collectionNumber: this.fireassetName.length
      })
      this.fireassetType = ''
      this.fireassetName = []
    },
    handleAddAccount () {
      this.$refs.crud.rowAdd()
    },
    handleSearchReset () {
      this.page.currentPage = 1
      this.page.pageSize = 10
      this.getList()
    },
    getList () {
      let serachPerson = {}
      let serachName = {}
      if (this.searchParams.name) {
        serachPerson = this.personList.find((item) => {//这里的userList就是上面遍历的数据源
          return item.value === this.searchParams.name;//筛选出匹配数据
        });
        if (serachPerson === undefined) {
          serachPerson = this.personList.find((item) => {//这里的userList就是上面遍历的数据源
            return item.label === this.searchParams.name;//筛选出匹配数据
          });
        }
        console.log('this.personList', this.personList)
        console.log('serachPerson', serachPerson)
        this.searchParams.name = serachPerson.label
      }
      const params = {
        pageNo: this.page.currentPage,
        pageSize: this.page.pageSize,
        collectionCode: this.searchParams.collectionCode,
        name: this.searchParams.name
      }
      const loading = this.$loading({
        lock: true,
        text: '请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$fetch(
        api.assetsManage.queryAssetsRecipientsList,
        params
      ).then(response => {
        setTimeout(() => {
          loading.close()
        }, 500);

        if (!response.success) {
          this.$message({
            message: response.msgContent,
            type: 'error',
            duration: 2000
          })
          return
        }
        this.tableData = response.returnObj ? Object.freeze([...response.returnObj.list]) : []
        this.page.total = response.returnObj ? response.returnObj.total : 0
        this.$refs.crud.selectClear()
      })
    },
    handleCurrentChange (val) {
      this.page.currentPage = val
      this.getList()
    },
    handleSizeChange (val) {
      this.page.currentPage = 1;
      this.page.pageSize = val
      this.getList()
    },
    handleSearchChange (param) {
      this.page.currentPage = 1;
      this.searchParams = param;
      this.getList(this.page);
    },
    handleView (row) {
      this.$refs.detail.open(row.collectionCode)
    },
    handleReturn (row) {
      this.$refs.assetsReturn.open(row)
    },
    handleCreate (addInfo, done) {
      this.$refs['crud'].$refs['form'].validate(valid => {
        if (!valid) {
          return false
        } else {
          const personNO = this.personList.find((item) => {
            return item.value === addInfo.name;//筛选出匹配数据
          })
          console.log('personNO', personNO)
          const params = this.addTableData.map(item => {
            return {
              fireassetType: Dic.findByLabel('SENU077', item.fireassetType),
              fireassetNames: item.fireassetName.split(","),
              name: personNO.label,
              workNo: personNO.value,
              collectionTime: Dates.format(addInfo.collectionTime, 'yyyy-MM-dd HH:mm:ss'),
              collectionPurpose: addInfo.collectionPurpose,
              collectionNumber: item.collectionNumber,
            }
          })
          this.$fetch(api.assetsManage.addAssetsRecipients, params).then(res => {
            if (res && res.success) {
              this.$message.success(res.msgContent)
              this.getList()
            } else {
              this.$message.error(res.msgContent)
            }
            done()
          })
        }
      })
    },
    closeDialog () {
      this.addShow = false;
      this.addTableData = [];
    },
    returnAssets () {
      this.getList()
    }
  }
}
</script>
<style lang="scss">
@import "../style/recipient.scss";
</style>